import {X} from "react-feather";
import {Children} from "interfaces";
import {ImgHTMLAttributes} from "react";
import Z from "react-medium-image-zoom";
import {Close, Container} from "./styled";
import {useTheme} from "styled-components";
import "react-medium-image-zoom/dist/styles.css";

interface ZoomProps extends Children {
  zoomImg?: ImgHTMLAttributes<HTMLImageElement>;
}

export const Zoom: React.FC<ZoomProps> = ({children, zoomImg}) => {
  const {black} = useTheme();
  return (
    <Z
      zoomImg={zoomImg}
      children={children}
      ZoomContent={({img, onUnzoom}) => (
        <Container>
          {img}
          <Close
            size={50}
            onClick={onUnzoom as any}
            icon={<X color={black} size={35} />}
          />
        </Container>
      )}
    />
  );
};
